import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';

@Component({
    selector: 'app-employers',
    templateUrl: './employers.component.html'
})
export class EmployersPageComponent implements OnInit {

    isLoggedIn: boolean = false

    constructor(private userService: UserService) { }

    ngOnInit() {
        this.isLoggedIn = this.userService.isLoggedin()
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/employers.component.ts